import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  font-family: ${fonts.body};
  color: ${semantic.text.primary};
  font-size: ${fonts.size.md};
  line-height: 1.6;

  p,
  blockquote,
  ul,
  ol,
  dl,
  table,
  pre {
    margin-top: 0;
    margin-bottom: ${space[4]};
  }

  > *:last-child {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3 {
    margin-top: ${space[5]};
    margin-bottom: ${space[4]};
    font-weight: ${fonts.weight.medium};
    line-height: 1.25;
    border-bottom: 1px solid ${semantic.border.subtle};
    padding-bottom: 0.3em;
  }

  h1 {
    font-size: 1.6em;
  }

  h2 {
    font-size: 1.4em;
  }

  h3 {
    font-size: 1.2em;
  }

  ul,
  ol {
    padding-left: 1.2em;
  }

  blockquote {
    margin-left: 0;
    padding: 0 1em;
    color: ${semantic.text.secondary};
    border-left: 0.25em solid ${semantic.border.default};

    & > :first-child {
      margin-top: 0;
    }

    & > :last-child {
      margin-bottom: 0;
    }
  }

  code {
    padding: 0.2em 0;
    margin: 0;
    font-size: 90%;
    background-color: rgba(0, 0, 0, 0.04);
    border-radius: ${layout.borderRadius};

    &::before,
    &::after {
      letter-spacing: -0.2em;
      content: ' ';
    }
  }

  pre {
    padding: ${space[4]};
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    background-color: ${semantic.bg.surfaceSubtle};
    border-radius: ${layout.borderRadius};

    code {
      background-color: transparent;
      padding: 0;

      &::before,
      &::after {
        content: none;
      }
    }
  }

  a {
    color: ${colors.primary};
    text-decoration: underline;

    &:hover {
      opacity: 0.85;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      padding: ${space[2]} ${space[3]};
      border: 1px solid ${semantic.border.default};
      text-align: left;
    }

    th {
      background-color: ${semantic.bg.surfaceSubtle};
      font-weight: ${fonts.weight.semiBold};
    }
  }
`;
